import React from "react";

export const FieldErrorWhenSave: React.FC<{ errorFields: string[] }> = ({ errorFields }) => {
  return (
    <ul className="text-red-500 p-0 pl-1">
      {errorFields.map((err, index) => (
        <li key={index}>{err}</li>
      ))}
    </ul>
  );
};
